import { z } from 'zod';
import {
  isInviteCode,
  normalizeInviteCode,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  USERNAME_MAX_LENGTH,
  USERNAME_MIN_LENGTH,
  USERNAME_PATTERN,
} from './auth';

export const usernameSchema = z
  .string()
  .trim()
  .min(USERNAME_MIN_LENGTH)
  .max(USERNAME_MAX_LENGTH)
  .regex(USERNAME_PATTERN);

export const passwordSchema = z.string().min(PASSWORD_MIN_LENGTH).max(PASSWORD_MAX_LENGTH);

export const inviteCodeSchema = z
  .string()
  .max(32)
  .transform(normalizeInviteCode)
  .refine(isInviteCode);

export const registerRequestSchema = z.object({
  inviteCode: inviteCodeSchema.optional(),
  username: usernameSchema,
  password: passwordSchema,
});

/** Login is lenient about format: a wrong username simply gives "wrong username or password". */
export const loginRequestSchema = z.object({
  username: z.string().trim().min(1).max(64),
  password: z.string().min(1).max(PASSWORD_MAX_LENGTH),
});

export const blockUserRequestSchema = z.object({
  username: z.string().trim().min(1).max(64),
  blocked: z.boolean(),
});
